import { Skeleton } from '../../ui';

export function LibrarySkeleton() {
  return (
    <>
      <div className="ts-title-row">
        <div className="space-y-2">
          <Skeleton height="h-7" width="w-52" />
          <Skeleton height="h-3" width="w-72" />
        </div>
      </div>

      {/* Search + filter bar */}
      <div className="card space-y-3 mb-4">
        <Skeleton height="h-9" width="w-full" />
        <div className="flex gap-2">
          {[0, 1, 2, 3, 4].map((i) => (
            <Skeleton key={i} height="h-6" width="w-16" shape="pill" />
          ))}
        </div>
      </div>

      {/* Section rows */}
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="card p-4 flex items-center justify-between mb-3">
          <Skeleton height="h-4" width="w-40" />
          <Skeleton height="h-4" width="w-20" />
        </div>
      ))}
    </>
  );
}
